import {
  LOAD_USED_AI_CREDITS,
  LOAD_USED_AI_CREDITS_FAILURE,
  LOAD_USED_AI_CREDITS_SUCCESS,
  UsedAiCreditsActions
} from "../actions";

export interface UsedAiCreditsState {
  loading: boolean;
  credits: IUsedAiCredits | null;
  error: string | null;
}

export const initialState: UsedAiCreditsState = {
  loading: false,
  credits: null,
  error: null
};

export interface IUsedAiCredits {
  subscriptionCategory: string;
  alreadyUsed: number;
  planLimit: number;
  additionalCredits: number;
  resetDate: string;
  subscriptionTitle: string;
  planTitle: string;
  hostingTrialExpireDate: string;
  editUsed?: number;
  editTotal?: number;
}

export function usedAiCreditsReducer(state = initialState, action: UsedAiCreditsActions): UsedAiCreditsState {

  switch (action.type) {
    case LOAD_USED_AI_CREDITS: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case LOAD_USED_AI_CREDITS_SUCCESS:
      return {
        ...state,
        loading: false,
        credits: action.payload.credits,
        error: null
      };

    case LOAD_USED_AI_CREDITS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
  }

  return state;
}
